import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CalendarCheck, ArrowRight, CheckCircle2 } from "lucide-react";
import MiniTimer from "@/components/landing/MiniTimer";

export default function DemoToolSection() {
  const scrollToRegister = () => {
    document.getElementById("lead-capture")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="demo-tool-section" className="py-12 md:py-20 bg-green-50">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2
          data-testid="demo-tool-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Try the Tool Teachers Use <span className="text-green-700">Most</span>
        </h2>
        <p className="mt-3 text-center text-slate-600 text-sm md:text-base">
          <strong>Admission Eligibility Checker</strong> — Just enter the student's Date of Birth and the app instantly tells the eligible class.
        </p>

        <div className="mt-10 max-w-md mx-auto">
          <Card className="demo-card-bg border-2 border-green-200 shadow-lg overflow-hidden">
            <div className="bg-green-700 px-5 py-3 flex items-center gap-2">
              <CalendarCheck className="w-5 h-5 text-white" />
              <span className="text-white font-semibold text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Admission Eligibility Checker
              </span>
            </div>
            <CardContent className="p-5 space-y-4">
              {/* Static inputs */}
              <div className="space-y-3">
                <div>
                  <label className="text-xs font-medium text-slate-500 uppercase tracking-wide">Date of Birth</label>
                  <div
                    data-testid="demo-dob-input"
                    className="mt-1 h-11 rounded-lg border border-green-200 bg-white px-4 flex items-center text-slate-800 font-medium"
                  >
                    12 / 05 / 2019
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-slate-500 uppercase tracking-wide">Admission Year</label>
                  <div
                    data-testid="demo-year-input"
                    className="mt-1 h-11 rounded-lg border border-green-200 bg-white px-4 flex items-center text-slate-800 font-medium"
                  >
                    2026
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-green-200" />

              {/* Static result */}
              <div data-testid="demo-result" className="bg-white rounded-xl border border-green-300 p-4">
                <p className="text-xs font-medium text-green-600 uppercase tracking-wide mb-3">Result</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-green-600" />
                    <span className="text-slate-700 text-sm">
                      Age: <strong className="text-slate-900">6 Years</strong>
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-green-600" />
                    <span className="text-slate-700 text-sm">
                      Eligible Class: <strong className="text-green-700 text-lg">Class I</strong>
                    </span>
                  </div>
                </div>
              </div>

              <Button
                data-testid="demo-try-free-btn"
                onClick={scrollToRegister}
                className="w-full h-11 bg-green-700 hover:bg-green-800 text-white rounded-lg font-semibold shadow-md"
              >
                Try This Tool Free
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
              <a
                href="https://teacherutilitytoolkit.in/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="demo-try-online-btn"
                className="mt-2 w-full h-10 inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-lg font-bold text-sm shadow-md transition-all"
              >
                ⚡ ଏଠାରେ ସିଧା ଚଲାନ୍ତୁ — No Download!
              </a>
              <div className="mt-2 flex justify-center">
                <MiniTimer />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
